export default __webpack_public_path__ + "static/solution-scale.url-ca78de6df2c6e5e80d3c491e06a6fbb8.svg";